import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import config from '../../config';
import { history } from '../../routes';
import { ToastContainer, notify } from '../../libraries/notifications';
import prescriptionsActions from '../../context/prescriptions/actions';
import { Form, Field } from 'react-final-form';
import TextareaInput from '../../components/forms/TextareaInput';
import Button from '../../components/commons/Button';
import LayoutSmall from '../../components/layout/LayoutSmall';
import userActions from '../../context/users/actions';
import PatientProfileImage from '../../components/customs/PatientProfileImage';
import PushNotifications from '../../components/PushNotifications';
import MessagesActions from '../../context/messages/actions';
import { getOwner } from '../../libraries/utils';
import ChatBubbleCard from '../../components/customs/ChatBubbleCard';

class Messages extends React.Component {

  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      user: null,
      messages: [],
    }
  }
  
  componentDidMount() {
      this.getUser();
      this.getUserMessages();
    }

  getUser = async () => {
    await this.props.onGetUser({id: this.props.auth.user.id})
    const { user } = this.props;
    if (user.error) { 
      notify(this.t(user.error.message));
    } else {
      this.setState({ user: user.item });
    }    
  }

  getUserMessages = async () => {
    await this.props.onGetAllMessages({ type: config.MESSAGES.TYPE.MESSAGE })
    const { messages } = this.props;
    if (messages.error) {
      notify(this.t(messages.error.message));
    } else {
      this.setState({ messages: messages.items });
    }
  }

  onSubmit = () => {
    console.log("onSubmit")
  }

  onSendPicture = () => {
    console.log("onSendPicture")
  }

  render() {
    const { user, messages } = this.state;
    
    return (
      <LayoutSmall
      main={{ className: ""}}
      header={{
        className: "bg-primary flex justify-between p-3",
        left: { icon: 'arrow_left', action: () => {history.push(config.ROUTES.HOME)} },
      }}
      container={{ className: "px-0"}}
      loading = {this.props.user.loading}
      >
        <main className="w-full h-full bg-base-200">
          <ToastContainer />
          <PushNotifications />
          <section className="text-primary-content p-1 text-center">
            <div className="container p-6">
              {
                user && user.json_data && <PatientProfileImage data={user} />
              }
            </div>
          </section>
          <section className="px-4 flex gap-4 mb-4">

          </section>

          <div className=" py-6 px-4 bg-base-200 rounded-t-3xl">

            <section className="mb-6">

              <div>
                {messages.map((message, index) => {
                  return (
                    <ChatBubbleCard
                      key={index}
                      messages={message}
                    />
                  )
                }
                )}
              </div>


              {
                <Form onSubmit={this.onSubmit}>
                  {({ handleSubmit, form, submitting, pristine, values }) => (

                    <section className="container p-3 mt-3">
                      <div className="relative">
                        <form onSubmit={handleSubmit} className="form control">
                          <Button
                            className="btn btn-outline btn-accent absolute left-0 top-0 rounded-l-none"
                            onClick={this.onSendPicture}
                            icon="photograph"
                          />
                          <Field
                            name="consulta"
                            component={TextareaInput}
                            placeholder="Escribe un mensaje"
                            inputClassName="w-full pr-16 input input-primary input-bordered"
                          />
                          <Button
                            className="btn btn-outline btn-accent absolute right-0 top-0 rounded-l-none"
                            onClick={handleSubmit}
                            icon="paper_airplane"
                            title="Enviar"
                          />
                        </form>
                      </div>
                    </section>
                  )}
                </Form>
              }



            </section>
          </div>
        </main>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    user: state.users.current,
    messages: state.messages.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGet: (id) => dispatch(prescriptionsActions.get(id)),
    onGetUser: (params) => dispatch(userActions.get(params)),
    onGetAllMessages: (params) => dispatch(MessagesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Messages));
